<template>
  <v-app>
    <div v-if="loading">
      <v-alert
        v-if="notAdminError"
          :value="true"
        type="error"
        transition="scale-transition"
      >
        Це сторінка для адміністрації, а ви, здається &mdash; не адміністратор 🧐
      </v-alert>
      <v-alert
        v-else-if="error"
        :value="true"
        type="error"
        transition="scale-transition"
      >
        Помилка при отриманні списку екзаменів! Подробиці в консолі розробника.
      </v-alert>
    </div>
    <div v-else-if="!error && !notAdminError">
      <NavBar/>
      <v-content>
        <router-view />
      </v-content>
    </div>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import status_codes from "@/config/status-codes";
import {urls} from "@/config";
import settings from "@/config/settings";

export default {
  name: "App",
  components: {
    NavBar
  },
  data() {
    return {
      error: false,
      notAdminError: false,
      loading: false
    };
  },
  async created() {
    try {
      this.loading = true;
      const queryParams = new URLSearchParams(window.location.search);
      await this.$store.dispatch("exams/getExams", {
        key: queryParams.get("userId") ? "all" : settings.startList,
        limit: queryParams.get("userId") ? 100 : null,
        userId: queryParams.get("userId")
      });
      this.loading = false;
    } catch (e) {
      switch (e.code) {
        case status_codes.UNAUTHORIZED:
          window.location.href = urls.signin;
          break;
        case status_codes.ACCESS_DENIED:
          this.notAdminError = true;
          break;
        default:
          console.warn({e});
          this.error = true;
      }
    }
  }
};
</script>
